import React from 'react'
import {LinksContainer} from './style'
import {SocialNav} from 'components/SocialNav'
import {withTheme} from 'styled-components'

export const Links = withTheme(({light,active,theme})=>(
    <LinksContainer light={light} active={active} >
        <SocialNav color={light&&!active?theme.color.black:theme.color.white}/>
    </LinksContainer>
)
)


